<template>
    <div class="xi">
        <hd-com></hd-com>
        <!-- <searchhdCom></searchhdCom> -->
        <div class="shopTab">
            <div class="shopTabBox">
                <div class="shopTabno">
                    商城首页
                </div>
            </div>
        </div>
        <div class="content-wrap">
            <div class="center-box">
                <div class="content clearfix" style="position: relative;">
                    <div class="center-top flex-space-between">
                        <div class="top-left flex-space-between">
                            <div class="title" @click="orderData(0)">商品广场</div>
                        </div>
                    </div>
                    <template v-if="shopList.length > 0">
                        <div class="center-center flex-start flex-wrap">
                            <div class="video-item flex-space-between-columns" v-for="(item, index) in shopList"
                                :key="index" @click="goDetail(item)">
                                <div class="item-img">
                                    <img :src=" Services.ossUpload + item.coverImageUrls1[0]"
                                        style="width:100%; height:100%">
                                </div>
                                <div class="desc-box  flex-space-between-columns">
                                    <div class="desc-top">
                                        <div class="title1">
                                            <!-- <el-tooltip class="item" effect="dark" :content="item.name"
                                                placement="top-start"> -->
                                                {{ item.name }}
                                            <!-- </el-tooltip> -->
                                        </div>
                                    </div>
                                    <div class="desc-bottom flex-space">
                                        <span class="bottom-right1"><span style="font-size: 12px;">￥</span>{{ item.ordinaryPrice }}</span>
                                        <span class="bottom-right2">￥{{ item.guidancePrice }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="page">
                            <el-pagination background layout="prev, pager, next,total" :page-size="15"
                                @current-change="handleCurrentChange" :current-page.sync="currentPage"
                                :total="DetailTotal">
                            </el-pagination>
                        </div>
                    </template>
                    <div v-else class="flex-center" style="margin:50px auto">
                        <img src="../../assets/img/video/blank_page.png" />
                    </div>

                </div>
            </div>
        </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>


import hdCom from '../../components/intshopheader'
import searchhdCom from '../../components/insearchHeader'

import ftCom from '../../components/footer'
// import rtBar from "../../components/right";
import { videoMain } from "../../components/video/video"
export default {
    name: "healthKnow",
    components: {
        hdCom,
        searchhdCom,
        ftCom,
        // rtBar
    },
    data() {
        var video = new videoMain(this.TokenClient, this.Services.shoppingMall)
        return {
            videoDomain: video,
            categoryId: 0,
            keyWord: ' ',
            pageIndex: 1,
            shopList: [],
            CategoriesList: [],
            curindex: -1,
            scrollW: 0,
            leftnum: 0,
            rightnum: 0,
            scrollW: 0,
            activeMenu: {
                id: 0,
                name: "全部",
                children: [{
                    id: 0,
                    name: "全部"
                }]
            },
            activeMenuChi: {
                id: 0,
                name: "全部"
            },
            orderLeft: 0,
            checkList: [],
            checkValue: 2,
            PageIndex: 1,
            PageTotal: 1,
            DetailTotal: 0,

            currentPage: 1, //初始页
        }
    },
    methods: {
        //分页点击事件
        handleCurrentChange: function (pageNum) {
            this.currentPage = pageNum;
            this.PageIndex = pageNum;
            this.Detail()
            // chrome
            document.body.scrollTop = 0;
            // firefox
            document.documentElement.scrollTop = 0;
            // safari
            window.pageYOffset = 0;
        },
        ChangeDetailPage(pageIndex) {
            this.PageIndex = pageIndex;
            this.Detail()
        },
        checkData() {
            this.videoList = []
            if (this.checkList.length == 0) {
                this.checkValue = 2
            }
            if (this.checkList.length == 1) {
                this.checkValue = this.checkList[0]
            }
            if (this.checkList.length == 2) {
                this.checkList.splice(0, 1)
                this.checkValue = this.checkList[0]
            }
            this.Detail()
        },
        orderData(num) {
            this.videoList = []
            this.orderLeft = num
            this.Detail()
            // 查询数据
        },
        selectMenuChi(i) {
            this.videoList = []
            this.activeMenuChi = this.activeMenu.children[i]
            this.categoryId = this.activeMenuChi.id
            this.Detail()
        },
        selectMenu(i) {
            this.videoList = []
            this.activeMenu = this.CategoriesList[i]
            this.activeMenuChi = this.activeMenu.children[0]
            this.categoryId = this.activeMenu.id
            this.Detail()
        },
        goDetail(e) {
            this.$router.push({
                path: './shopDetail',
                query: {
                    id: e.id
                }
            })
        },
        //详情获取
        Detail() {
            var _this = this;
            let params = `${_this.PageIndex}`
            _this.videoDomain.getAppletPages(params, function (data) {
          		for (let m=0; m<data.data.results.length; m++) {
                        var f = data.data.results[m].coverImageUrls.split(',') 
                        data.data.results[m].coverImageUrls1 = f
                }
                _this.shopList = data.data.results
                _this.PageIndex = data.data.pageIndex;
                _this.PageTotal = data.data.pageCount;
                _this.DetailTotal = data.data.dataTotal;
            },
                function (error) {

                })
        },
    },
    mounted() {
        this.Detail();
    },
    destroyed() {
        //销毁监听
    },
}
</script>
<style lang="scss" scoped>
.shopTab {
    border-bottom: 1px solid #00AFB5;
    padding-top: 30px;
}
.shopTabBox {
    width: 70%;
    display: flex;
    align-items: center;
    margin-left: 15%;
}
.shopTabno {
    font-size: 15px;
    color: #FFFFFF;
    font-weight: bold;
    padding: 10px 50px;
    background: #00AFB5;
    cursor: pointer;
}
.shopTabChecked {
    font-size: 15px;
    padding: 10px 50px;
     cursor: pointer;
}
.banner {
    height: 116px;
    background: url("../../assets/img/jbk_banner.png")center no-repeat;
}

.banner-text {
    width: 1200px;
    margin: 0 auto;

    h3 {
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }

    p {
        font-size: 18px;
        color: #ffffff;

        a {
            color: #ffffff;
            font-size: 14px;
            margin: 0 5px;
        }
    }
}

.content-wrap {
    background: #F5F6F6;
}


.content {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;

}

.menu-box {
    width: 100%;
    background: #fff;
    height: auto;

    .box {
        align-items: flex-start !important;
        margin-bottom: 10px;
    }

    .menu-title {
        width: 90px;
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-content {
        width: calc(100% - 95px);
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-item {
        width: auto;
        margin: 0 5px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        height: 40px;
        padding: 0 10px;
    }

    .menu-item:hover {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
        cursor: pointer;
    }

    .menuActive {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
    }
}

.center-box {
    .center-top {
        height: 120px;

        .top-left {
            .title {
                font-weight: bold;
                font-size: 20px;
                color: #333333;
                cursor: pointer;
            }
            div.active {
                color: #00998B;
            }

            .line-div {
                width: 1px;
                height: 16px;
                background: #D9D9D9;
                margin: 0 30px;
            }
        }
    }

    .top-center {
        width: auto;
        height: 70px;
        line-height: 70px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
        background: url("../../assets/img/video/m_title.png")center no-repeat;
    }

    .center-center {
        .video-item {
            // width: 23.5%;
            // height: 330px;
            padding:30px 25px;
            margin-left: 10px;
            margin-bottom: 30px;
            background: #ffffff;
            border-radius: 0px 0px 4px 4px;
            cursor: pointer;

            .item-img {
                width: 180px;
                height: 180px;
                background: #000;
                border-radius: 4px 4px 0px 0px;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px 4px 0px 0px;
                }
            }

            .desc-box {
                margin-top: 30px;
                .desc-top {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    .title1 {
                        width: 180px;
                        overflow:hidden; 
                        // text-overflow:ellipsis;
                        // display:-webkit-box;
                        // -webkit-box-orient:vertical;
                        // -webkit-line-clamp:2; 
                        -webkit-line-clamp: 2;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        height: 60px;
                    }
                }
            }

            .desc-bottom {
                // width: 100%;
               
                .bottom-right1 {
                   color: #F50F12;
                    font-size: 16px;
                }

                .bottom-right2 {
                    font-size: 12px;
                    color: #999999;
                    text-decoration-line: line-through;
                    margin-left: 5px;
                }

            }
            .top-right {
                width: auto;
                height: 70px;
                line-height: 70px;
                font-size: 24px;
            }

        }

        .video-item:hover {
            box-shadow: 0px 8px 15px 0px rgba(186, 186, 186, 0.3);
        }

        .video-item:nth-child(4n) {
            margin-right: 0;
        }

    }

}


.healthKnow .el-radio {
    margin-right: 30px;
}

#page ::v-deep .el-pagination {
    text-align: center;
    margin: 30px auto;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    background-color: #fff;
}

#page ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #01C2AC;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    border-radius: 2px;
}
</style>
